import { render, staticRenderFns } from "./product-replacement-dialog.vue?vue&type=template&id=853a9fa4&scoped=true"
import script from "./product-replacement-dialog.vue?vue&type=script&lang=js"
export * from "./product-replacement-dialog.vue?vue&type=script&lang=js"
import style0 from "./product-replacement-dialog.vue?vue&type=style&index=0&id=853a9fa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853a9fa4",
  null
  
)

export default component.exports